import { Link, useNavigate } from "react-router-dom";
import { useOperator } from "@/lib/operator";
import { LogOut, ArrowLeft } from "lucide-react";

/**
 * Shared header for every operator screen: Wilson logo + operator avatar + (optional) back button.
 * Matches the public site branding: navy strip on white, red accents.
 */
export default function OperatorHeader({ back, title }) {
  const { operator, logout } = useOperator();
  const navigate = useNavigate();
  const onLogout = async () => { await logout(); navigate("/app"); };

  return (
    <header className="bg-white border-b-4 border-[#c41e3a] px-4 py-3 flex items-center justify-between shadow-sm">
      <div className="flex items-center gap-3 min-w-0">
        {back && (
          <Link to={back} className="text-slate-600 hover:text-[#c41e3a] p-1 shrink-0" data-testid="op-header-back">
            <ArrowLeft size={20} />
          </Link>
        )}
        <Link to="/app" className="flex items-center gap-3 min-w-0">
          <img src="/wilson-logo.png" alt="Wilson Contractors" className="h-10 w-auto shrink-0" />
          <div className="min-w-0 hidden sm:block">
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 leading-tight">Field App</div>
            {title && (
              <div className="font-display font-black text-base text-[#1a1a5c] leading-tight truncate">
                {title}
              </div>
            )}
          </div>
        </Link>
      </div>
      {operator && (
        <div className="flex items-center gap-2">
          <div className="text-right hidden sm:block">
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Signed in</div>
            <div className="text-sm font-bold text-[#1a1a5c]">{operator.name}</div>
          </div>
          <div className="w-10 h-10 rounded-full bg-[#1a1a5c] grid place-items-center text-white font-black text-sm">
            {operator.initials}
          </div>
          <button onClick={onLogout} title="Sign out" data-testid="op-logout"
                  className="text-slate-500 hover:text-[#c41e3a] p-2">
            <LogOut size={18} />
          </button>
        </div>
      )}
    </header>
  );
}
